import { render, staticRenderFns } from "./default.vue?vue&type=template&id=372bf818&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=372bf818&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372bf818",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EsNavbar: require('/home/runner/work/flash-ui/flash-ui/components/EsNavbar.vue').default,EsMessage: require('/home/runner/work/flash-ui/flash-ui/components/EsMessage.vue').default})
